import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import { CssBaseline, CircularProgress, Container, Grid, Tabs, Tab, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Chip, MenuItem, Divider } from "@material-ui/core";
import ReplayIcon from '@material-ui/icons/Replay';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import MyMaterialTable from '../../components/table';
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import SectionCard from '../../components/section-card';
import Pagination from '@material-ui/lab/Pagination';
import { ProvisioningStatusBadge, ContractStatusBadge } from '../../components/status-badge';
import EmptyStateCard from '../../components/empty-state-card';
import BuildIcon from '@material-ui/icons/Build';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminBillingService from '../../services/admin-billing.service';
import Api from "../../services/api";

const PAGE_SIZE = 10;

class AdminProvisioningQueue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            resultList: [],
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            tabValue: 0,
            statusFilter: '',
            modeFilter: '',
            retryDialogOpen: false,
            retryId: null,
            retryWorkspace: '',
        };
        this.closeNotification = this.closeNotification.bind(this);
    }

    handleRetryProvisioning = () => {
        const { retryId } = this.state;
        const intl = this.props.intl;
        this.setState({ loading: true, retryDialogOpen: false });
        adminBillingService.retryProvisioning(retryId)
            .then(result => {
                if (result.data.success) {
                    this.setState({ loading: false, openNotification: true, notificationVariant: 'success', notificationMessage: intl.formatMessage({ id: 'admin.provisioning.retry.success' }) });
                    this.getItens();
                } else {
                    this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: 'process.error' }) });
                }
            })
            .catch(err => {
                this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: intl.formatMessage({ id: 'process.error' }) });
                Api.kickoff(err);
            });
    }

    componentDidMount() {
        this.getItens(1);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === "reload") {
            this.componentDidMount();
        }
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getItens(page);
    }

    setPagination(count, page) {
        let totalPage = Math.ceil(count / PAGE_SIZE);
        this.setState({ totalPages: totalPage });
        if (count > 0) {
            if (page == 1) {
                this.setState({ pageStart: 1, pageEnd: Math.min(count, PAGE_SIZE) });
            } else {
                let pageStart = ((page - 1) * PAGE_SIZE) + 1;
                this.setState({ pageStart: pageStart, pageEnd: Math.min(page * PAGE_SIZE, count) });
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 });
        }
    }

    handleTabChange = (e, newValue) => {
        const filters = ['', 'pending', 'processing', 'completed', 'failed', 'partial'];
        this.setState({ tabValue: newValue, statusFilter: filters[newValue], page: 1 }, () => {
            this.getItens(1);
        });
    }

    getItens(page = 1) {
        this.setState({ loading: true });
        const offset = (page - 1) * PAGE_SIZE;

        adminBillingService.getProvisioningQueue(PAGE_SIZE, offset, this.state.statusFilter, this.state.modeFilter)
            .then(result => {
                if (result.data.success) {
                    const data = result.data.data;
                    const count = data.totalcount || 0;
                    const items = data.items || [];
                    this.setState({ count: count });
                    this.setPagination(count, page);

                    const formattedList = items.map(item => ({
                        ...item,
                        createdAtText: item.createdat ? new Date(item.createdat).toLocaleString('pt-BR') : '-',
                        currentStepText: item.currentstep ? `${item.currentstep}/${item.totalsteps || '?'}` : '-',
                    }));

                    this.setState({ loading: false, resultList: formattedList });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                const intl = this.props.intl;
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='xl' style={{ paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <SectionCard
                                    context="provisioning"
                                    title={intl.formatMessage({ id: "admin.provisioning.title" })}
                                    subtitle="Fila de provisionamento de tenants — execuções em andamento, falhas e conclusões"
                                    divider={false}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} style={{ marginBottom: 8 }}>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label="Tipo"
                                    select
                                    value={this.state.modeFilter}
                                    onChange={(e) => this.setState({ modeFilter: e.target.value, page: 1 }, () => this.getItens(1))}
                                    fullWidth
                                    size="small"
                                    SelectProps={{ native: true }}
                                    InputLabelProps={{ shrink: true }}
                                >
                                    <option value="">Todos</option>
                                    <option value="trial">Trial</option>
                                    <option value="dedicated">Dedicado</option>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Tabs value={this.state.tabValue} onChange={this.handleTabChange} indicatorColor="primary" textColor="primary" style={{ marginBottom: 16 }}>
                            <Tab label={intl.formatMessage({ id: "admin.trials.filter.all" })} />
                            <Tab label={intl.formatMessage({ id: "admin.provisioning.status.pending" })} />
                            <Tab label={intl.formatMessage({ id: "admin.provisioning.status.processing" })} />
                            <Tab label={intl.formatMessage({ id: "admin.provisioning.status.completed" })} />
                            <Tab label={intl.formatMessage({ id: "admin.provisioning.status.failed" })} />
                            <Tab label="Parcial" />
                        </Tabs>

                        {this.state.resultList.length === 0 && !this.state.loading ? (
                            <EmptyStateCard
                                context="success"
                                icon={<BuildIcon style={{ fontSize: 56, color: '#bdbdbd' }} />}
                                title="Nenhum item na fila"
                                description="Não há provisionamentos em andamento ou pendentes."
                            />
                        ) : (
                            <MyMaterialTable
                                title=""
                                columns={[
                                    { title: 'Contrato', field: 'contractid' },
                                    { title: intl.formatMessage({ id: "name" }), field: 'companyname' },
                                    { title: 'Workspace', field: 'workspace' },
                                    {
                                        title: 'Tipo',
                                        field: 'provisioningmode',
                                        render: rowData => {
                                            const mode = rowData.provisioningmode || 'trial';
                                            return <Chip label={mode === 'dedicated' ? 'Dedicado' : 'Trial'} size="small"
                                                style={{ backgroundColor: mode === 'dedicated' ? '#bbdefb' : '#fff9c4', color: mode === 'dedicated' ? '#0d47a1' : '#f57f17', fontWeight: 500 }} />;
                                        }
                                    },
                                    {
                                        title: 'Status Contrato',
                                        field: 'contractstatusid',
                                        render: rowData => rowData.contractstatusid ? <ContractStatusBadge statusId={rowData.contractstatusid} /> : '-'
                                    },
                                    {
                                        title: 'Status Provisionamento',
                                        field: 'status',
                                        render: rowData => <ProvisioningStatusBadge status={rowData.status} />
                                    },
                                    { title: intl.formatMessage({ id: "admin.provisioning.step" }), field: 'currentStepText' },
                                    { title: intl.formatMessage({ id: "admin.provisioning.created" }), field: 'createdAtText' },
                                    {
                                        title: intl.formatMessage({ id: "actions" }),
                                        field: 'actions',
                                        render: rowData => rowData.status === 'failed' ? (
                                            <Tooltip title={intl.formatMessage({ id: "admin.provisioning.retry" })}>
                                                <IconButton size="small" onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.setState({ retryDialogOpen: true, retryId: rowData.id, retryWorkspace: rowData.workspace });
                                                }}>
                                                    <ReplayIcon style={{ color: '#ff9800' }} />
                                                </IconButton>
                                            </Tooltip>
                                        ) : null
                                    },
                                ]}
                                data={this.state.resultList}
                                rowClick={(event, rowData) => {
                                    // Overlay padrão durante a transição até a página de detalhe montar
                                    // e tomar conta do próprio loading via onLoadingChange.
                                    this.setState({ loading: true });
                                    this.props.addCurrentProvisioning(rowData);
                                    this.props.history.push(`/${this.props.match.params.lang}/admin-provisioning-detail`);
                                }}
                            />
                        )}

                        <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                            <Grid item xs={12} md={3}>
                                <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                            </Grid>
                        </Grid>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
                        {/* Retry Confirmation Dialog */}
                        <Dialog open={this.state.retryDialogOpen} onClose={() => this.setState({ retryDialogOpen: false })} maxWidth="xs" fullWidth PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', backgroundColor: '#f5f7fa' }}>
                                <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>{intl.formatMessage({ id: "admin.provisioning.retry.title" })}</Typography>
                                <IconButton size="small" onClick={() => this.setState({ retryDialogOpen: false })} style={{ color: '#9e9e9e' }}><CloseIcon fontSize="small" /></IconButton>
                            </div>
                            <Divider />
                            <DialogContent style={{ padding: '16px 24px' }}>
                                <Typography>{intl.formatMessage({ id: "admin.provisioning.retry.confirm" }, { workspace: this.state.retryWorkspace })}</Typography>
                            </DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                <Button onClick={() => this.setState({ retryDialogOpen: false })} style={{ textTransform: 'none', fontWeight: 500 }}>{intl.formatMessage({ id: "cancel" })}</Button>
                                <Button variant="contained" onClick={this.handleRetryProvisioning} style={{ backgroundColor: '#ff9800', color: '#fff', textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>
                                    {intl.formatMessage({ id: "admin.provisioning.retry" })}
                                </Button>
                            </div>
                        </Dialog>

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminProvisioningQueue.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminProvisioningQueue)));
